// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
import Popper from "popper.js";
window.jQuery = $;
window.$ = $;

// Required
require('./vendor/loadingbar/loading-bar');
require("bootstrap");
require("jquery-validation");
require('slick-carousel')

// Swiper
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

// Logo loading bar
var bar = new ldBar("#calc-logo", {
  "fill-dir": "ltr"
});

bar.set(75);

// Bootstrap tooltip
jQuery(function () {
  jQuery('[data-toggle="tooltip"]').tooltip(
    { offset: 230,
      trigger: 'click',
      template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div><a class="tooltip-close d-block" href="#"><span class="icon"><img class="w-75" src="dist/images/x.svg" /></span></a></div>'
    }
  )
  jQuery('body').on('click', 'a.tooltip-close', function(e) {
    e.preventDefault();
    jQuery(this).parents('.tooltip').remove();
  });

})

jQuery(document).ready(function() {
  let validationOptions = {
    errorClass: 'text-danger calc-error',
    errorPlacement: function(error, element) {
      error.appendTo( element.parents(".calc-field"));
    },
    showErrors: function(errorMap, errorList) {
      let currentCalcForm = this.currentForm.attr('id');
      jQuery('#' + currentCalcForm + ' .calc-error-summary').html("Your form contains "
        + this.numberOfInvalids()
        + " errors, see details above.");
      this.defaultShowErrors();
    }
  }

  jQuery('#go-to-step-2').on('click', function(e) {
    e.preventDefault();
    jQuery('#calc-form-1').validate(validationOptions);
    if (jQuery('#calc-form-1').valid()) {
      // code to reveal step 2
      jQuery(this).parents('.calc-step').fadeOut(300, function() {
        jQuery('[data-toggle="tooltip"]').tooltip('hide');
        jQuery(this).find('.calc-error-summary').hide();
        window.scrollTo(0, 0);
        jQuery('#calc-step-2').fadeIn(300);
      });
    } else {
      jQuery('#calc-form-1').find('.calc-error-summary').show();
    }
  });

  jQuery('#go-to-step-3').on('click', function(e) {
    e.preventDefault();
    jQuery('#calc-form-2').validate(validationOptions);
    if (jQuery('#calc-form-2').valid()) {
      var formData = jQuery('form').serialize();
      $.ajax({
        url: "calc.php",
        type: "post",
        data: formData,
        success: function (response) {
          var JSONresponse = jQuery.parseJSON( response );
          console.log(JSONresponse);

          // Append results
          jQuery.each(JSONresponse, function(key,value) {
            jQuery('.' + key).text(value);
          });

          // Append electricity results colours
          jQuery('.electricity-result-rating').css("color", JSONresponse['electricity-rating-colour']);
          jQuery('.electricity-result-annual-kwh-per-sqm').css("color", JSONresponse['electricity-rating-colour']);
          jQuery('.electricity-result-annual-pounds').css("color", JSONresponse['electricity-rating-colour']);

          // Decide how to show result
          if(JSONresponse['electricity-total-rating-text-display'] == 'kWh') {
            jQuery('#electricity-result-pounds').hide();
            jQuery('#electricity-result-kwh').show();
            jQuery("#electricity-result-container button").removeClass('active');
            jQuery("#electricity-result-container button[data-unit='kwh']").addClass('active');
          }

          if(JSONresponse['electricity-total-rating-text-display'] == 'pounds') {
            jQuery('#electricity-result-kwh').hide();
            jQuery('#electricity-result-pounds').show();
            jQuery("#electricity-result-container button").removeClass('active');
            jQuery("#electricity-result-container button[data-unit='pounds']").addClass('active');
          }

          // If the electricity result is higher than 'highest' plot 100%
          if((JSONresponse['electricity-result-annual-kwh-per-sqm-int']) > (JSONresponse['electricity-highest-threshold'])) {
            var elec_plot_amount = parseInt(JSONresponse['electricity-highest-threshold']);
          } else {
            var elec_plot_amount = parseInt(JSONresponse['electricity-result-annual-kwh-per-sqm-int']);
          }

          // Append gas results colours
          jQuery('.gas-result-rating').css("color", JSONresponse['gas-rating-colour']);
          jQuery('.gas-result-annual-kwh-per-sqm').css("color", JSONresponse['gas-rating-colour']);
          jQuery('.gas-result-annual-pounds').css("color", JSONresponse['gas-rating-colour']);

          // Decide how to show result
          if(JSONresponse['gas-total-rating-text-display'] == 'kWh') {
            jQuery('#gas-result-pounds').hide();
            jQuery('#gas-result-kwh').show();
            jQuery("#gas-result-container button").removeClass('active');
            jQuery("#gas-result-container button[data-unit='kwh']").addClass('active');
          }
          if(JSONresponse['gas-total-rating-text-display'] == 'pounds') {
            jQuery('#gas-result-kwh').hide();
            jQuery('#gas-result-pounds').show();
            jQuery("#gas-result-container button").removeClass('active');
            jQuery("#gas-result-container button[data-unit='pounds']").addClass('active');
          }

          // If the gas result is higher than 'highest' plot 100%
          if((JSONresponse['gas-result-annual-kwh-per-sqm-int']) > (JSONresponse['gas-highest-threshold'])) {
            var gas_plot_amount = parseInt(JSONresponse['gas-highest-threshold']);
          } else {
            var gas_plot_amount = parseInt(JSONresponse['gas-result-annual-kwh-per-sqm-int']);
          }

          // Create progress bars
          var electricityResult = new ldBar("#electricity-result", {
            "stroke": JSONresponse['electricity-rating-colour'],
            "preset": "fan",
            "fill-dir": "ttb",
            "min": 0,
            "max": JSONresponse['electricity-highest-threshold']
          });

          var gasResult = new ldBar("#gas-result", {
            "stroke": JSONresponse['gas-rating-colour'],
            "preset": "fan",
            "fill-dir": "ttb",
            "min": 0,
            "max": JSONresponse['gas-highest-threshold']
          });
          
          if(JSONresponse['hide-epc'] == true) {
            jQuery('#calc-epc-section').hide();
          }

          if (JSONresponse['electricity-result-annual-kwh-per-sqm']) {
            jQuery('#electricity-result-container').show();
            jQuery('#elec-epc-tab').addClass('active show');
            jQuery('#elec-epc').addClass('active show');
          }

          if (JSONresponse['gas-result-annual-kwh-per-sqm']) {
            jQuery('#gas-result-container').show();
          }

          if (!JSONresponse['gas-result-annual-kwh-per-sqm']) {
            jQuery('#gas-epc-tab').parent('li').hide();
          }

          if (!JSONresponse['electricity-result-annual-kwh-per-sqm']) {
            jQuery('#gas-epc-tab').addClass('active show');
            jQuery('#gas-epc').addClass('active show');
            jQuery('#elec-epc-tab').parent('li').hide();
          }





          jQuery('#calc-step-2').fadeOut(300, function() {
            window.scrollTo(0, 0);
            jQuery('#calc-step-3').fadeIn(300, function() {
              // init Swiper:
              var mySwiper = new Swiper('.swiper-container', {
                loop: true,
                autoHeight: true, //enable auto height
                breakpoints: {
                  // when window width is <= 499px
                  499: {
                    slidesPerView: 1,
                    spaceBetweenSlides: 50
                  },
                  // when window width is <= 768px
                  768: {
                    slidesPerView: 2,
                    spaceBetweenSlides: 50
                  },
                  // when window width is <= 999px
                  999: {
                    slidesPerView: 3,
                    spaceBetweenSlides: 30
                  }
                },
                spaceBetween: 30,
                // centeredSlides: true,
                // If we need pagination
                pagination: {
                  el: '.swiper-pagination',
                },
                // Navigation arrows
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }
              })
              electricityResult.set(elec_plot_amount);
              gasResult.set(gas_plot_amount);
            });
          });
        },
        error: function(jqXHR, textStatus, errorThrown) {
          alert("There was a problem calculating your result");
        }
      });
    } else {
      jQuery('#calc-form-2').find('.calc-error-summary').show();
    }
  });
});


// Header

// Back buttons
jQuery('.btn-back').click(function(e){
  e.preventDefault();
  let itemToShow = jQuery(this).attr('data-show');
  jQuery(this).parents('.calc-step').fadeOut(300, function() {
    jQuery('#calc-step-' + itemToShow).fadeIn(300);
  });
});

// Close buttons
jQuery('.btn-close').click(function(e){
  e.preventDefault();
  jQuery('#calc-tool').fadeOut(300);
});


// Step 0
jQuery('.btn-start').click(function(e){
  e.preventDefault();
  jQuery('#calc-tool').fadeIn(300);
  window.scrollTo(0, 0);
});


// Step 1

  // Comparison buttons
  jQuery('.btn-comparison').click(function(e){
    e.preventDefault();
    let itemsToCompare = jQuery(this).val();
    switch(itemsToCompare) {
      case 'both':
          jQuery('#calc-electricity-usage').fadeIn(300);
          jQuery('#calc-gas-usage').fadeIn(300);
          jQuery('#calc-elec').val('true');
          jQuery('#calc-gas').val('true');
          jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery("#calc-electricity-usage").offset().top
          }, 350);
        break;
      case 'gas':
        jQuery('#calc-electricity-usage').fadeOut(300, function() {
          jQuery('#calc-gas-usage').fadeIn(300);
          jQuery('#calc-gas').val('true');
          jQuery('#calc-elec').val('false');
          jQuery('#calc-electricity-usage').find('input').val('');
          jQuery('#calc-electricity-usage').find('select').prop('selectedIndex',0);
          jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery("#calc-gas-usage").offset().top
          }, 350);
        });
        break;
      case 'electricity':
        jQuery('#calc-gas-usage').fadeOut(300, function() {
          jQuery('#calc-electricity-usage').fadeIn(300);
          jQuery('#calc-elec').val('true');
          jQuery('#calc-gas').val('false');
          jQuery('#calc-gas-usage').find('input').val('');
          jQuery('#calc-gas-usage').find('select').prop('selectedIndex',0);
          jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery("#calc-electricity-usage").offset().top
          }, 350);
        });
        break;
      default:
    }
    jQuery('.btn-comparison').removeClass('active');
    jQuery(this).addClass('active');
    jQuery('#calc-business-sector').fadeIn(300);
    jQuery('#calc-business-size').fadeIn(300);


    // Tabs Selection
    jQuery('.calc-selection .nav-link').on('shown.bs.tab', function (e) {
      // e.target // newly activated tab
      var previousTabID = e.relatedTarget.attr('href');
      jQuery(previousTabID).find('input').val('');
      jQuery(previousTabID).find('select').prop('selectedIndex',0);
    })
  });

// End Step 1


// Step 3

// Result unit toggler
jQuery('.btn-toggle-unit').click(function(e) {
  e.preventDefault();
  var unitToShow = jQuery(this).attr('data-unit');
  var typeToShow = jQuery(this).attr('data-type');
  jQuery('#' + typeToShow + '-result-container .result-container').hide();
  jQuery(this).parents('.nav').find('.btn-toggle-unit').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('#' + typeToShow + '-result-container #' + typeToShow + '-result-' + unitToShow).show();
});

// End Step 3
